import { SurveyFillTranslation } from './surveyFill.translation.en.ts';

export const surveyFillTranslation: SurveyFillTranslation = {
  backToCertification: 'Wróć do certyfikacji',
  finish: 'Zakończ',
  label: 'Ankieta',
  loading: 'Ładowanie ankiety...',
  next: 'Dalej',
  notFound: 'Nie znaleziono ankiety',
  openAnswer: {
    label: 'Twoja odpowiedź ({{length}}/1000)',
  },
  progress: 'Postęp: {{percent}}%',
  progressLabel: 'Postęp',
  questionCounter: 'Pytanie {{current}} z {{total}}',
  questionLabel: 'Pytanie {{number}}',
  submitting: 'Zapisywanie...',
  summary: {
    allCategoriesMet: 'Spełniłeś/aś wszystkie progi kompetencji. Tak trzymaj!',
    answer: 'Odpowiedź',
    backToCertification: 'Wróć do certyfikacji',
    categoriesCount_few: '{{count}} obszary wymaga poprawy',
    categoriesCount_many: '{{count}} obszarów wymaga poprawy',
    categoriesCount_one: '{{count}} obszar wymaga poprawy',
    categoriesCount_other: '{{count}} obszary wymagają poprawy',
    competencyWorkRequired: 'Obszary do rozwoju',
    goToResources: 'Przejdź do materiałów',
    greatJob: 'Świetna robota!',
    howToImprove: 'Jak się poprawić',
    intro:
      'Zakończyłaś / zakończyłeś pierwszy ważny etap procesu certyfikacji. Dziękujemy za rzetelną samoocenę — to dobry punkt wyjścia do dalszego rozwoju i wzmacniania standardów operacyjnych, które bezpośrednio wpływają na doświadczenie naszych klientów w sklepach.',
    introGapsHint:
      'Poniżej znajdziesz obszary, w których warto pogłębić wiedzę lub umiejętności. Skupienie się na nich pomoże Ci jeszcze lepiej przygotować się do kolejnych etapów procesu certyfikacji.',
    loading: 'Ładowanie wyników...',
    procedure: 'Procedura',
    questionNumber: 'Pytanie #{{number}}: ',
    questionsCount_few: '{{count}} pytania',
    questionsCount_many: '{{count}} pytań',
    questionsCount_one: '{{count}} pytanie',
    questionsCount_other: '{{count}} pytania',
    supportMaterials: 'Materiały pomocnicze',
    title: 'Wyniki ankiety',
    viewAnswers: 'Zobacz swoje odpowiedzi',
  },
  unavailable: {
    cancelled: 'Ta ankieta została anulowana i nie można jej już rozpocząć ani kontynuować.',
    completed: 'Ta ankieta została zakończona i nie można jej już rozpocząć ani kontynuować.',
    deadlineExpired:
      'Termin wypełnienia tej ankiety minął i nie można jej już rozpocząć ani kontynuować.',
    title: 'Ankieta niedostępna',
  },
};
